// -didim_realty_world
import React from "react";
import { Link } from "react-router-dom";

interface FooterProps {
  layoutData?: any;
}

const Footer: React.FC<FooterProps> = ({ layoutData }) => {

  // layoutData'dan Footer verilerini al
  const headerData = layoutData?.Header;
  const footerData = layoutData?.Footer;

  const pageData = headerData?.[0]; // Header içinde mail, tel gibi bilgiler var

  const contactSection = footerData?.find((item: any) =>
    item.title === "iletişim"
  );

  const quickLinksSection = footerData?.find((item: any) =>
    item.title === "hızlı-linkler"
  );

  const popularLocationsSection = footerData?.find((item: any) =>
    item.title === "popüler-yerler"
  );

  const popularTypesSection = footerData?.find((item: any) =>
    item.title === "popüler-türler"
  );

  const contactInfo = footerData?.filter((item: any) =>
    item.parent?.includes(contactSection?._id)
  ) || [];

  const quickLinks = footerData?.filter((item: any) =>
    item.parent?.includes(quickLinksSection?._id)
  ).map((item: any) => ({
    label: item.title,
    path: item.url || '#'
  })) || [];

  const popularLocations = footerData?.filter((item: any) =>
    item.parent?.includes(popularLocationsSection?._id)
  ).map((item: any) => ({
    label: item.title,
    path: item.url || '#'
  })) || [];

  const popularTypes = footerData?.filter((item: any) =>
    item.parent?.includes(popularTypesSection?._id)
  ).map((item: any) => ({
    label: item.title,
    path: item.url || '#'
  })) || [];

  const phoneInfo = contactInfo.find((item: any) =>
    item.title?.toLowerCase().includes('telefon') || item.title?.toLowerCase().includes('whatsapp')
  );

  const emailInfo = contactInfo.find((item: any) =>
    item.email
  );

  const addressInfo = contactInfo.find((item: any) =>
    item.title?.includes('Atatürk') || item.title?.includes('Bulvarı')
  );



  return (
    <footer className="bg-secondary text-gray-300 py-16 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-2 mb-6">
              <div className="size-8 bg-primary rounded flex items-center justify-center text-white">
                <span className="material-symbols-outlined text-xl">home_work</span>
              </div>
              <h3 className="text-xl font-bold text-white">Didim Realty World</h3>
            </div>
            <p className="text-sm leading-relaxed mb-6 text-gray-400">
              {footerData?.[0]?.content || 'Your trusted partner for real estate in Didim and the Aegean coast. We help you find not just a house, but a home.'}
            </p>
            <div className="flex gap-4">
              <a
                href={pageData?.facebook || '#'}
                target="_blank"
                rel="noopener noreferrer"
                className="size-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-primary transition-colors text-white"
              >
                <span className="material-symbols-outlined text-lg">public</span>
              </a>
              <a
                href={pageData?.instagram || '#'}
                target="_blank"
                rel="noopener noreferrer"
                className="size-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-primary transition-colors text-white"
              >
                <span className="material-symbols-outlined text-lg">share</span>
              </a>
              <a
                href={`mailto:${pageData?.mail || 'info@didimrealty.com'}`}
                className="size-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-primary transition-colors text-white"
              >
                <span className="material-symbols-outlined text-lg">mail</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6">{quickLinksSection?.title || 'Quick Links'}</h4>
            <ul className="space-y-3">
              {quickLinks.map((link: any) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm hover:text-primary transition-colors flex items-center gap-2"
                  >
                    <span className="material-symbols-outlined text-xs">chevron_right</span>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Popular Locations */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6">{popularLocationsSection?.title || 'Popular Locations'}</h4>
            <ul className="space-y-3">
              {popularLocations.map((location: any) => (
                <li key={location.path}>
                  <Link
                    to={location.path}
                    className="text-sm hover:text-primary transition-colors flex items-center gap-2"
                  >
                    <span className="material-symbols-outlined text-xs">location_on</span>
                    {location.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6">{contactSection?.title || 'Contact Us'}</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <span className="material-symbols-outlined text-primary mt-0.5">location_on</span>
                <span className="text-sm text-gray-400">
                  {addressInfo?.title || 'Atatürk Blv. No:123, Didim, Aydın, Turkey'}
                </span>
              </li>
              <li className="flex items-center gap-3">
                <span className="material-symbols-outlined text-primary">call</span>
                <a
                  href={`tel:${phoneInfo?.['tel-no'] || '+905421234567'}`}
                  className="text-sm text-gray-400 hover:text-primary transition-colors"
                >
                  {phoneInfo?.['tel-no'] || '+90 542 123 45 67'}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <span className="material-symbols-outlined text-primary">mail</span>
                <a
                  href={`mailto:${emailInfo?.email || 'info@didimrealty.com'}`}
                  className="text-sm text-gray-400 hover:text-primary transition-colors"
                >
                  {emailInfo?.email || 'info@didimrealty.com'}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-500">
            © {new Date().getFullYear()} Didim Realty World. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-gray-500">
            <Link to="/legal/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/legal/terms" className="hover:text-white transition-colors">Terms & Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;